module.exports = __webpack_public_path__ + "static/media/chevron-down-blue.1b6a35cb.svg";